import {
    createField,
    updateField,
} from '../../actions';
import {
    EVENT_STEP_VALIDATE,
} from '../../helpers/consts';

export class SourceSelectField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Select an option'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.translations = options.translations;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId;
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;

        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$customSelect = document.createElement('div');
        this.$fieldSelect = document.createElement('select');
        this.$fieldMessage = document.createElement('span');

        this.$fieldSelect.innerHTML = `
        <option disabled selected value>${__('Choose')}</option>`

        let options = `<option value="2">${__('Via another entrepreneur')}</option>
        <option value="3">${__('Through my accountant')}</option>
        <option value="4">${__('Via a partner of Exact')}</option>
        <option value="5">${__('Via colleagues / family / friends')}</option>
        <option value="1">${__('Via the Internet')}</option>
        <option value="99">${__('Others')}</option>
        `;
        if (this.translations.source_elements) {
            const elements = JSON.parse(this.translations.source_elements);
            if (elements && elements.option_text && elements.option_value
            && elements.option_text.length && elements.option_value.length) {
                options = ``;
                Object.keys(elements.option_value).forEach(key => {
                    options += `<option value="${  elements.option_value[key]   }">${  elements.option_text[key]   }</option>`;
                });
            }
        }

        this.$fieldSelect.innerHTML += options;

        this.$fieldSelect.id = this.id;
        this.$fieldSelect.required = false;
        this.$fieldSelect.value = this.value ? this.value : '';
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--source')
        $fieldLabel.classList.add('field-label');
        this.$customSelect.classList.add('formControls');
        this.$fieldSelect.classList.add('field-select--country', 'custom-select', 'form-control');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');
        this.$customSelect.append(this.$fieldSelect);

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$customSelect);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldSelect.addEventListener('blur', this.validate.bind(this));
        this.$fieldSelect.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    getSelectElement() {
        return this.$fieldSelect;
    }

    validate() {
        this.$fieldSelect.classList.remove('is-invalid');
        this.$fieldSelect.classList.remove('is-valid');
        this.isValid = (this.$fieldSelect.value !== '');

        if (this.isValid) {
            // Valid credit card number
            this.$fieldSelect.classList.remove('is-invalid');
            this.$fieldSelect.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldSelect.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
            this.isValid = false;
        }

        this.store.dispatch(updateField(this.id, this.$fieldSelect.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default SourceSelectField;
